import React from 'react'
import t from 'prop-types'

const TwoUp = ({ children }) => {
  return (
    <div className="md:grid md:grid-cols-2 gap-10 gap-y-24">
      {children.map((child, index) => (
        <div key={index} className="mb-16 md:mb-0 last:mb-0">
          {child}
        </div>
      ))}
    </div>
  )
}

TwoUp.propTypes = {
  children: t.node.isRequired,
}

TwoUp.defaultProps = {}

export default TwoUp
